import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const EXCLUDE_PREFIXES = ["/marketing", "/admin", "/accounting", "/auth", "/login", "/register"];

/**
 * Fire-and-forget page-view event collector for the storefront.
 * Powers /marketing/traffic/live. Errors are swallowed so a marketing
 * outage never affects normal browsing.
 */
export default function TrafficTracker() {
  const location = useLocation();

  // Anonymous heartbeat every 30s while the tab is visible → live "people on site" graph.
  useEffect(() => {
    if (EXCLUDE_PREFIXES.some((p) => location.pathname.startsWith(p))) return;
    let vid = localStorage.getItem("kolt.vid");
    if (!vid) { vid = `v_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`; localStorage.setItem("kolt.vid", vid); }
    const beat = () => {
      if (document.visibilityState !== "visible") return;
      let cart_items = 0, cart_total = 0;
      try {
        const items = JSON.parse(sessionStorage.getItem("koltprinting_cart_v1") || "[]");
        cart_items = items.reduce((n, i) => n + (i.quantity || 0), 0);
        cart_total = items.reduce((n, i) => n + (i.line_total || 0), 0);
      } catch { /* ignore */ }
      // Landing source is captured once per browser session (referrer + UTM of the first page).
      let src = null;
      try {
        src = sessionStorage.getItem("kolt.src");
        if (!src) {
          const q = new URLSearchParams(window.location.search);
          src = JSON.stringify({ referrer: document.referrer || null, utm_source: q.get("utm_source"), utm_medium: q.get("utm_medium"), utm_campaign: q.get("utm_campaign"), gclid: q.get("gclid") ? 1 : 0, landing: window.location.pathname });
          sessionStorage.setItem("kolt.src", src);
        }
        src = JSON.parse(src);
      } catch { src = null; }
      api.post("/marketing/traffic/heartbeat", { visitor_id: vid, path: window.location.pathname, cart_items, cart_total, source: src }).catch(() => {});
    };
    beat();
    const iv = setInterval(beat, 30000);
    document.addEventListener("visibilitychange", beat);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", beat); };
  }, [location.pathname]);

  useEffect(() => {
    if (EXCLUDE_PREFIXES.some((p) => location.pathname.startsWith(p))) return;
    const search = new URLSearchParams(location.search);
    api.post("/marketing/traffic/event", {
      visitor_id: localStorage.getItem("kolt.vid") || undefined,
      path: location.pathname,
      referrer: document.referrer || null,
      utm_source: search.get("utm_source"),
      utm_medium: search.get("utm_medium"),
      utm_campaign: search.get("utm_campaign"),
    }).catch(() => { /* swallow */ });
  }, [location.pathname, location.search]);

  return null;
}
